import styled from "styled-components";
import { Modal as AntdModal } from "antd";

export const ModalWrapper = styled(AntdModal)`
  max-width: 450px;
  .ant-modal-body {
    padding: 0;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${({ $error }) => ($error ? "#d32f2f" : "#ccc")};
  border-radius: 6px;
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  margin: 8px 0;

  &:focus {
    border-color: ${({ $error }) => ($error ? "#d32f2f" : "#0C53BB")} !important;
    box-shadow: 0 0 0 2px
      ${({ $error }) =>
        $error ? "rgba(211, 47, 47, 0.2)" : "rgba(12, 83, 187, 0.2)"};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`;

export const Header = styled.div`
  font-size: 20px;
  font-weight: 600;
  font-family: 'Manrope', sans-serif;
  margin-bottom: 8px;
`;

export const ConfirmButton = styled.button`
  padding: 7px 11px;
  height: 32px;
  background: #0c53bb;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;

export const CancelButton = styled.button`
  padding: 7px 11px;
  background: #f2f2f2;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #DDE2E9
`;

export const ErrorText = styled.div`
  color: #d32f2f;
  font-size: 12px;
  margin-top: 8px;
  margin-left: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
`;
